import { AxiosResponse } from "../interface";
import { axiosInstanceWebsite } from "../instance";
import { Product } from "../../components/products/ProductInterface";

export interface ProductsPageResponse {
  items: Product[];
  page: number;
  size: number;
  total_items: number;
  total_pages: number;
  funnel_context?: ProductFunnelContext | null;
}

export interface ProductFunnelContext {
  website_id: string;
  website_name: string;
  products: ProductFunnelContextProduct[];
}

export interface ProductFunnelContextProduct {
  product_id: string;
  parent_product_id?: string | null;
  product_type: string;
  relation_kind: "GLOBAL" | "VERSION" | "OFFER";
  price?: number | string | null;
  price_formatted?: string | null;
  offer_price?: number | string | null;
  offer_price_formatted?: string | null;
  effective_price?: number | string | null;
  effective_price_formatted?: string | null;
  country_code?: string | null;
  currency_code?: string | null;
  offer_country_code?: string | null;
  offer_currency_code?: string | null;
  effective_country_code?: string | null;
  effective_currency_code?: string | null;
}

interface GetProductsParams {
  page?: number;
  size?: number;
  search?: string;
  selected_product_id?: string;
  selected_funnel_id?: string;
}

export const getProductsPage = async (params?: GetProductsParams): Promise<ProductsPageResponse> => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/store/product`,
    { params }
  );

  if (Array.isArray(response.data)) {
    const items = response.data.reverse();
    return {
      items,
      page: params?.page ?? 0,
      size: params?.size ?? items.length,
      total_items: items.length,
      total_pages: items.length > 0 ? 1 : 0,
      funnel_context: null,
    };
  }

  return {
    items: response.data?.items || [],
    page: response.data?.page ?? params?.page ?? 0,
    size: response.data?.size ?? params?.size ?? 15,
    total_items: response.data?.total_items ?? 0,
    total_pages: response.data?.total_pages ?? 0,
    funnel_context: response.data?.funnel_context ?? null,
  };
};

export const getProducts = async () => {
  const response = await getProductsPage();
  return response.items;
};

export const putProduct = async (data: Product) => {
    const response: AxiosResponse = await axiosInstanceWebsite.put(
      `/store/product/${data.id}`,
      data
    );
    return response.data;
};

export const patchProductPriceCurrency = async (
  productId: string,
  data: { name: string; price: number; currency_code: string; country_code?: string | null }
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.patch(
    `/store/product/${productId}/price-currency`,
    data
  );
  return response.data;
};

export const patchWebsiteProductPricing = async (
  websiteId: string,
  productType: string,
  data: { price: number; currency_code?: string | null; country_code?: string | null }
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.patch(
    `/websites/${websiteId}/products/${productType}/pricing`,
    data
  );
  return response.data;
};

export const cloneProduct = async (productId: string) => {
  const response = await axiosInstanceWebsite.post(
    `/store/product/${productId}/clone`
  );
  return response.data;
};
